/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_All_MethodsInputs */

const vi_expense_filter_all_methods = /** @type {(inputs: Expense_Filter_All_MethodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả phương thức`)
};

/**

* @param {Expense_Filter_All_MethodsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_all_methods = /** @type {((inputs?: Expense_Filter_All_MethodsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_All_MethodsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_all_methods(inputs)
});